import { HttpService } from "@root/services/http";
import { ADMIN_GET_PROFILE, ADMIN_LOGIN_ENDPOINT, DELETE_ADMIN_ENDPOINT, MAKE_ADMIN_ENDPOINT, } from "../endPoints";

export class AdminAuthService extends HttpService {
    login = async (baseAuthUrl: string, payload: any): Promise<any> => {
        try {
            const url = `${baseAuthUrl}/${ADMIN_LOGIN_ENDPOINT}`
            const apiResponse = await this.post(url, payload);
            return apiResponse
        } catch (error) {
            throw error;
        }
    };
    makeAdmin = async (baseAuthUrl: string, payload: any): Promise<any> => {
        try {
            const url = `${baseAuthUrl}/${MAKE_ADMIN_ENDPOINT}`
            const apiResponse = await this.post(url, payload);
            return apiResponse
        } catch (error) {
            throw error;
        }
    };
    deleteAdmin = async (baseAuthUrl: string, adminId: any): Promise<any> => {
        try {
            const url = `${baseAuthUrl}/${DELETE_ADMIN_ENDPOINT}/${adminId}`
            const apiResponse = await this.patch(url, {});
            return apiResponse
        } catch (error) {
            throw error;
        }
    };
    getProfile = async (baseAuthUrl: string,): Promise<any> => {
        try {
            const url = `${baseAuthUrl}/${ADMIN_GET_PROFILE}`
            const apiResponse = await this.get(url);
            return apiResponse
        } catch (error) {
            throw error;
        }
    };
}